import { useCallback, useEffect, useMemo, useRef } from "react";
import { useAuthenticationContext } from "~/providers/AuthenticationProvider";
import styles from "./CompanySelection.module.less";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useGetFilePaths } from "~/hooks/useGetFilePaths";
import { PT_DEFAULT_LOGO } from "../../constants/path";
import { useNavigate } from "react-router-dom";
import { PAGE_HOME } from "~/constants/page";
import { useLanguage } from "~/hooks/useLanguage";
import Scrollbars from "react-custom-scrollbars";
const CompanySelection = () => {
  const navigate = useNavigate();
  const { handleSetToken, userCompanyInfos, setUserCompanyInfos } =
    useAuthenticationContext();
  const { formatMessage } = useLanguage();

  const selectCompanyTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const companiesLogoS3Key = useMemo(
    () =>
      userCompanyInfos
        ?.filter((t) => t.companyLogoURL !== undefined)
        ?.map((c) => c.companyLogoURL) as string[],
    [userCompanyInfos],
  );

  const filePaths = useGetFilePaths(
    companiesLogoS3Key ? companiesLogoS3Key : [],
    userCompanyInfos && userCompanyInfos.length > 0
      ? userCompanyInfos[0].token
      : undefined,
  );

  const getCompanyLogo = useCallback(
    (key?: string) => {
      return key != ""
        ? filePaths?.find((f) => f.key === key)?.path
        : PT_DEFAULT_LOGO;
    },
    [filePaths],
  );

  const selectCompany = useCallback(
    (token: string) => {
      handleSetToken(token);
      selectCompanyTimeoutRef.current = setTimeout(() => {
        navigate(PAGE_HOME);
      }, 1000);
    },
    [navigate, handleSetToken],
  );

  useEffect(() => {
    return () => {
      if (selectCompanyTimeoutRef.current) {
        clearTimeout(selectCompanyTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div className={styles.companySelection}>
      <div className={styles.header}>
        <div onClick={() => setUserCompanyInfos(undefined)}>
          <ArrowLeftOutlined className={styles.backButton} />
        </div>
        <div className={styles.welcomePane}>
          <div className={styles.welcome}>
            {formatMessage("CompanySelection.Label.Welcome")}
          </div>
          <div className={styles.userName}>
            {userCompanyInfos?.[0].userName}
          </div>
          <div className={styles.description}>
            {formatMessage("CompanySelection.Label.SelectCompany")}
          </div>
        </div>
      </div>
      <div className={styles.companiesPane}>
        {userCompanyInfos && userCompanyInfos.length > 0 && (
          <Scrollbars autoHeight autoHeightMin={250}>
            <div className={styles.companyList}>
              {userCompanyInfos.map((acc) => (
                <div
                  className={styles.company}
                  key={acc.companyId}
                  onClick={() => selectCompany(acc.token)}
                >
                  <img
                    src={getCompanyLogo(acc.companyLogoURL)}
                    className={styles.companyLogo}
                  />
                  <span className={styles.companyName}>{acc.companyName}</span>
                </div>
              ))}
            </div>
          </Scrollbars>
        )}
      </div>
    </div>
  );
};

export default CompanySelection;
